import { render, staticRenderFns } from "./UnNominationConfirmationModal.vue?vue&type=template&id=5e804fb0&scoped=true"
import script from "./UnNominationConfirmationModal.vue?vue&type=script&lang=js"
export * from "./UnNominationConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./UnNominationConfirmationModal.vue?vue&type=style&index=0&id=5e804fb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e804fb0",
  null
  
)

export default component.exports